// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import promise from 'es6-promise';
promise.polyfill();
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import VueClipboard from 'vue-clipboard2'  // 复制到粘贴板
//  im插件
import webim from '../webim/webim'

import i18n from './lang' //语言包
import store from '../store/store'
import global from '../utils/global'
import http from '../utils/http'
import WITSBOX_ENV_PARAM from '../utils/common'
import {breadUrlMapMixin} from './mixins/breadUrlMap'
import Vant from 'vant'
import 'vant/lib/index.css'
import Print from 'vue-print-nb'
Vue.use(Print)
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueClipboard)
// 注入一下路径和面包削名字的翻译
Vue.mixin(breadUrlMapMixin)
Vue.prototype.request = axios
Vue.prototype.global = global
Vue.prototype.request = http
Vue.prototype.webim = webim
Vue.prototype.WITSBOX_ENV_PARAM = WITSBOX_ENV_PARAM
import stuBreadcrumb from '@/components/common/stuBreadcrumb'
Vue.component('stuBreadcrumb',stuBreadcrumb)
import textFormat from '../utils/textFormat'
Vue.use(textFormat)

// 引入swiper
import { Swipe, SwipeItem } from 'vant'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)
Vue.use(Vant)
Vue.use(Swipe).use(SwipeItem)
import { Toast, Dialog } from 'vant'
Vue.prototype.Toast = Toast
Vue.prototype.Dialog = Dialog
/* eslint-disable no-new */
  
var _hmt = _hmt || []
window._hmt = _hmt // 必须把_hmt挂载到window下，否则找不到
;(function () {
  var hm = document.createElement('script')
  hm.src =
    'https://hm.baidu.com/hm.js?' +
    (location.host && location.host.indexOf('t.witsbox.com') > -1
      ? 'c6c0396a372d6d321fff325db43a2ff5'
      : '2f52da83d8ea3a7d5427f859646deb5e')
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
})()

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',
  data: {
    Bus: new Vue()
  }
})




// WEBPACK FOOTER //
// ./src/main.js